import React, { useState, useEffect } from 'react';
import { Card } from '@mui/material'
import Container from '@mui/material/Container'
import menuIcon from '../assets/icons/icons8-menu-30.png'
import closeIcon from '../assets/icons/icons8-close-50.png'
import { Link } from 'react-router-dom';
import { isCollectorEnabled } from '../../../helpers/collectorSession';
import { isStudioLoggedIn } from '../../../helpers/studioSignupSession';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const closeMobileMenu = () => setMenuOpen(false);
  const studioLoggedIn = isStudioLoggedIn();

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const links = (
    <>
      <li>
        <Link to="/studio" onClick={closeMobileMenu}>Studio</Link>
      </li>
      {isCollectorEnabled() && (
        <li>
          <Link to="/collectors" onClick={closeMobileMenu}>My Collection</Link>
        </li>
      )}
      <li>
        <Link to="/pricing" onClick={closeMobileMenu}>Pricing</Link>
      </li>
      <li>
        <Link to={studioLoggedIn ? "/dashboard" : "/login"} onClick={closeMobileMenu}>
          {studioLoggedIn ? "Open Studio" : "Studio login"}
        </Link>
      </li>
      <li><a href="/home#contact" onClick={closeMobileMenu}>Contact</a></li>
    </>
  );

  return (
    <>
      <Card className='Header-Card'>
        <Container className='Header-Container'>
          <Link to="/home">
            <div className='Hastakala-logo'>
              <span className='sp1'>Hastkala</span>{' '}
              <span className='sp2'>Paramanak</span>
              <p>Supporting the makers, Protecting the buyers</p>
            </div>
          </Link>
          <ul className='Header-routes desktop-header'>
            {links}
          </ul>
          <div className='mobile-header'>
            <img
              onClick={() => setMenuOpen(!menuOpen)}
              src={menuOpen ? closeIcon : menuIcon}
              width={menuOpen ? 20 : 30}
              height={menuOpen ? 20 : 30}
              alt={menuOpen ? 'close' : 'menu'}
            />
          </div>
        </Container>
      </Card>
      {(menuOpen && screenWidth < 678) && (
        <div
          className='mobile-header'
          onClick={(event) => {
            if ((event.target as HTMLElement).closest("a")) return;
            closeMobileMenu();
          }}
        >
          <ul className='Header-routes-mobile'>
            {links}
          </ul>
        </div>
      )}
    </>
  )
}

export default Header
